import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { Home } from "./screens/Home";
import Navbar from "./component/Header&Footer/Header";
import { Footer } from "./component/Header&Footer/Footer";
import { useEffect, useState } from "react";
import AOS from "aos";
import "aos/dist/aos.css"; // Import AOS styles
import SplashScreen from "./component/HomeComponent/SplashScreen";

function App() {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(false);
    }, 1500); // 2 seconds

    return () => clearTimeout(timer);
  }, []);
  useEffect(() => {
    AOS.init(); // Initialize AOS
  }, []);
  return (
    <>
      <Router>
        <Navbar />
        <Routes>
          <Route path="*" element={loading ? <SplashScreen /> : <Home />} />
        </Routes>
        <Footer />
      </Router>
    </>
  );
}

export default App;
